/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Destructive_Writes_LabelInputs */



/**
* | output |
* | --- |
* | "May take irreversible actions without asking" |
*
* @param {Agent_Builder_Destructive_Writes_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_destructive_writes_label = /** @type {((inputs?: Agent_Builder_Destructive_Writes_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Destructive_Writes_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Darf unumkehrbare Aktionen ohne Rückfrage ausführen")
	return /** @type {LocalizedString} */ ("May take irreversible actions without asking")
});